<div class="container my-2 search-filter-container">
    <div formGroupName="searchFilter" class="row">
        <div class="col-4">
            <mat-form-field class="start-date-field">
                <input matInput [matDatepicker]="date" placeholder="* Start Date" [(ngModel)]="startDate" formControlName="startDate" [min]="startDateMin" [max]="startDateMax">
                <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
                <mat-datepicker #date></mat-datepicker>

                <mat-error>
                    Please enter a valid date (dd/MM/yyyy)
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field class="start-time-field">
                <input matInput [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" placeholder="* Select Time" [(ngModel)]="time" formControlName="time">
                <owl-date-time [pickerType]="'timer'" #dt4></owl-date-time>

                <mat-error>
                    Please enter a valid time (HH:mm AM/PM)
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field class="duration-field">
                <mat-select placeholder="* Duration" [(ngModel)]="duration" formControlName="duration">
                    <mat-option *ngFor="let duration of [2, 10, 30, 60, 120, 240]" [value]="duration">
                        {{duration | humanDuration:'m':'1'}}
                    </mat-option>
                </mat-select>

                <mat-error>
                    Please inform the segment duration
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <button mat-button class="float-left" (click)="clear()" type="reset">CLEAR</button>
        </div>
        <div class="col-6">
            <button mat-button class="float-right" type="submit">APPLY</button>
        </div>
    </div>
</div>